{
  "port": "Port",
  "token": "Token",
  "tokenHint": "Printed in the game's console (live link listening on …?token=) and written to <pack data>/admin/livelink.json.",
  "connect": "Connect",
  "disconnect": "Disconnect",
  "connected": "Connected to {{game}} ({{pack}}), scene {{scene}}.",
  "title": "Live",
  "lead": "The running game over the live link: start a run with any heroes (you and/or bots), make a hero use a power, fight arena series, rebuild floors, run the benches and type console commands. Watch it in the game's window, or in the live view here.",
  "sectionsLabel": "Live sections",
  "sections": {
    "play": "Play",
    "arena": "Arena",
    "floor": "Floor & benches",
    "console": "Console",
    "help": "How it works"
  },
  "needGame": "Connect to a running game above: this page drives a game, it cannot start one.",
  "answers": "Game answers",
  "link": {
    "title": "Connect to the game",
    "step1": "Start the game on this machine with the live link on: tick the Admin box in the Launcher, or run it with --admin (the Unity Editor in Play mode and development builds have it on).",
    "step2": "The port is 47800 unless the game was started with --admin-port=<n>.",
    "step3": "Paste the token the game prints in its console (live link listening on …?token=), also written to {{file}}; --admin-token=<token> fixes one.",
    "originOk": "This page ({{origin}}) is allowed by the game as it is.",
    "originFlag": "The game only lets known pages connect: start it with",
    "info": "{{game}} · pack {{pack}}{{version}} · Unity {{unity}} · scene {{scene}} · {{where}}",
    "editor": "Editor",
    "build": "build",
    "mismatch": "The game plays the pack {{game}}, the workshop shows {{pack}}: the heroes and monsters listed here may not exist in that game. Pick the matching pack in the pack bar, or connect to the other game."
  },
  "view": {
    "title": "Live view",
    "watch": "▶ Watch",
    "stop": "■ Stop",
    "rate": "Frames",
    "fps": "{{fps}} / s",
    "hud": "HUD",
    "hudHint": "Include the game's HUD (health bars, cooldowns)",
    "hint": "The game's view, refreshed over the live link (the game draws it; the page only shows it)",
    "alt": "The game's view",
    "off": "Live view: off",
    "connect": "Live view: connect to the game first (Live tab)",
    "noCommand": "This game's live link has no view.frame (update the live link package in delve-core)"
  },
  "play": {
    "party": "Party",
    "partyHint": "Up to 4 heroes. You play one seat (keyboard and mouse or a pad, in the game window); bots play the others. A party of bots plays by itself, a good way to watch a class.",
    "seatClass": "P{{n}} hero class",
    "seatWho": "P{{n}} played by",
    "whoHint": "You, or a bot and its skill (reaction, dodging, ability timing)",
    "you": "you",
    "bot": "bot {{skill}}",
    "botOption": "Bot · {{skill}}",
    "skill": {
      "Rookie": "Rookie",
      "Normal": "Normal",
      "Veteran": "Veteran"
    },
    "noClass": "(no hero class)",
    "run": "Run",
    "mode": "Mode",
    "dungeon": "Dungeon",
    "arena": "Arena",
    "dungeonHint": "Fogged floors, keys, stairs.",
    "arenaHint": "The biome's arena, waves.",
    "biome": "Biome",
    "difficulty": "Difficulty",
    "catalogFirst": "(the Run Catalog's first)",
    "catalogMedium": "(Medium)",
    "seed": "Seed",
    "seedHint": "0 = random",
    "rule": "Arena rule",
    "survival": "Survival: endless, scaling waves",
    "trial": "Trial: fixed waves and a final boss",
    "start": "▶ Start in the game",
    "startHint": "Loads the game's dungeon scene with this party and run, as its lobby and Run Setup do. The run is marked modified: it never counts for progression.",
    "noSeat": "Tick at least one seat and pick its class.",
    "foreign": "Not started: {{ids}} belong to another pack than the game's ({{pack}}). Pick the run again.",
    "now": "In the game now",
    "scene": "Scene {{scene}}",
    "noHero": "Scene {{scene}}: no hero. Start a run.",
    "down": "down",
    "noPartyCommand": "This game's live link cannot pick heroes yet (update the live link package in delve-core).",
    "cast": "Use a power",
    "castHint": "Makes a hero press a button now, aimed at the nearest monster: the real cast (animation, effects, damage, cooldown).",
    "hero": "Hero",
    "slot": {
      "basic": "Basic",
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "dash": "Dash"
    },
    "showcase": "Showcase",
    "showcaseHint": "Player 1 becomes the hero's class and uses one power again and again on a target dummy (resource and cooldown refilled). Without a hero in the game, a dungeon starts with that class first.",
    "showcaseSlot": "Power",
    "showcaseStart": "Showcase",
    "showcaseStop": "■ Stop showcase"
  },
  "arena": {
    "intro": "Team A against team B in the game's arena scene: heroes (bots; tick You to play one) and monsters. Watch / play: one round at normal speed, in the game window. Run series: many rounds, faster, for balance numbers. Every class vs every class: the win-rate matrix. The results below: wins, damage dealt and taken, time before death.",
    "team": "Team {{team}}",
    "fighter": "Fighter",
    "kind": "Kind",
    "kinds": {
      "hero": "hero",
      "monster": "monster"
    },
    "count": "How many",
    "countOf": "How many {{name}}",
    "you": "You",
    "youPlay": "You play {{name}}",
    "youHint": "You play this hero (one in the fight); the others are bots",
    "youMark": "(you)",
    "remove": "Remove",
    "removeOne": "Remove {{name}}",
    "empty": "No fighter yet.",
    "addTo": "Fighter to add to team {{team}}",
    "pick": "Add a hero or a monster…",
    "heroes": "Heroes",
    "other": "Other",
    "horde": "(horde)",
    "add": "Add",
    "clear": "Clear",
    "difficulty": "Difficulty",
    "arenaDifficulty": "(the arena's)",
    "depth": "Floor",
    "depthHint": "Floor the monsters are scaled for (+health and damage per floor, as in a run)",
    "rounds": "Rounds",
    "speed": "Speed (×)",
    "timeout": "Time limit (s)",
    "scene": "Scene",
    "sceneHint": "The game's arena scene",
    "watch": "Watch / play (1 round, normal speed)",
    "series": "Run series",
    "seriesHint": "The rounds above, at the speed above: balance numbers",
    "matrix": "Every class vs every class",
    "matrixHint": "Each hero class against each other one, one bot each, the rounds above per pair",
    "stop": "Stop",
    "idle": "Add fighters to both teams, then start.",
    "needBoth": "Each team needs at least one fighter.",
    "fewHeroes": "The Hero Sheet lists fewer than two hero classes.",
    "opening": "Opening the arena…",
    "stopping": "Stopping after this frame…",
    "fight": "Fight {{n}}/{{of}}…",
    "fightPair": "Fight {{n}}/{{of}}: {{a}} vs {{b}}…",
    "finished": "Arena: {{rounds}} round(s) done.",
    "failed": "Arena: {{error}}",
    "roundsDone_one": "{{count}} round",
    "roundsDone_other": "{{count}} rounds",
    "draws_one": "{{count}} draw",
    "draws_other": "{{count}} draws",
    "average": "average {{seconds}} s",
    "fighters": "Fighters",
    "teamCol": "Team",
    "roundsCol": "Rounds",
    "teamWins": "Team wins",
    "dealt": "Damage dealt",
    "taken": "Damage taken",
    "dps": "Damage / s",
    "survives": "Survives",
    "diesAt": "Dies at",
    "matrixTitle": "Class against class",
    "matrixRead": "The row's win rate against the column, over both team orders.",
    "roundList": "Rounds",
    "round": "Round",
    "winner": "Winner",
    "length": "Length",
    "draw": "draw"
  },
  "floor": {
    "floor": "Floor",
    "floorHint": "Rebuilds the current dungeon floor (Dungeon scene): the same seed and floor give the same layout.",
    "biome": "Biome",
    "currentBiome": "(current biome)",
    "seed": "Seed",
    "depth": "Floor",
    "rebuild": "Rebuild floor",
    "rebuilt": "Floor rebuilt: seed {{seed}}, floor {{depth}}, {{biome}}",
    "metrics": "Metrics",
    "metricsHint": "Damage, kills, time-to-kill and frame time per second, written as CSV files on the game's machine.",
    "metricsStart": "Start recording",
    "metricsStop": "Stop and write CSV",
    "metricsWritten": "Metrics written to {{path}}",
    "metricsFolder": "Written on the game's machine to",
    "benches": "Benches",
    "benchesHint": "Floor bench: bots play the listed biomes and floors and a report is written. Horde bench: the frame cost of growing hordes. The reports are written on the game's machine.",
    "benchBiomes": "Biomes",
    "benchBiomesHint": "Biome names, comma-separated",
    "benchDepths": "Floors",
    "benchSeeds": "Seeds",
    "benchDifficulty": "Difficulty",
    "benchTimeout": "Timeout (s)",
    "benchFloors": "Run floor bench (bots)",
    "hordeCounts": "Horde counts",
    "benchHorde": "Run horde perf bench",
    "benchDone": "Bench finished: {{what}}",
    "report": "Last report, on the game's machine:",
    "copy": "Copy",
    "copied": "Copied"
  },
  "console": {
    "hint": "Any admin console command, as typed in the game's console (help lists them: spawn, wave, heal, kill, level, talent…). Up / Down: history. Every answer of the game, from the other sections too, is logged here.",
    "output": "Console output",
    "command": "Console command",
    "placeholder": "e.g.  spawn skeleton 5   wave 20   heal   kill   level 5   help",
    "run": "Run",
    "help": "Help",
    "clear": "Clear"
  },
  "help": {
    "title": "How the Live tab works",
    "intro": "The workshop drives the game through the live link, a local WebSocket (ws://127.0.0.1, port 47800 or --admin-port) that admin builds open: the Unity Editor in Play mode, development builds, and builds started with --admin (the Launcher's Admin box). The page talks to the game on your machine only; nothing goes through the portal.",
    "connectTitle": "Connecting",
    "connect": "The game checks the token (printed in its console and written to <pack data>/admin/livelink.json) and the page's origin: localhost, 127.0.0.1 and the deployed workshop are allowed, any other with --admin-origin=<origin>. A refusal looks like a game that does not answer.",
    "play": [
      "Party: up to four heroes. Each seat is a hero class and who drives it: you (keyboard and mouse or a pad, in the game window) or a bot (the game's AI teammates, three skill levels). Only one seat can be you.",
      "Run: a dungeon (fogged floors, keys, stairs) or an arena (the biome's arena, waves), in a biome and a difficulty. Seed 0 = a new random floor each time.",
      "Start loads the game's dungeon scene with that party, exactly as the lobby and Run Setup do. Runs started from the workshop are marked modified: they never count for progression.",
      "Use a power: a hero presses one of its buttons now (basic attack, abilities 1-4, dash), aimed at the nearest monster: the real cast with its animation, effects, damage and cooldown.",
      "Showcase: player 1 becomes the chosen class and uses one power again and again on a target dummy. The Heroes tab's Powers have the same button, and the Bestiary shows a monster's looks and hordes in the game.",
      "Live view: small pictures of the game's view a few times a second, next to the controls."
    ],
    "arena": "Team A against team B in the game's arena scene: heroes (bots, or you on one of them) and monsters, one fight to watch or play, a fast series for balance numbers (wins, damage, time before death), or every class against every other. The game runs the fights; the workshop composes them and reads the results.",
    "floor": "Rebuild floor rebuilds the current dungeon floor from a seed (same seed = same floor). Metrics record damage, kills and frame time per second into CSV files. The benches run bots through floors, or measure a horde's cost, and write a report; the page shows where the game wrote it. The console takes any admin command (help lists them).",
    "tuningTitle": "Tuning while playing",
    "tuning": "In Tuning, Send live sends each change to the connected game at once: watch the effect in the game window."
  }
}
